/**
 * Lottie Library
 * Loaded conditionally via ACF theme options
 */

import lottie from 'lottie-web';
import { create } from '@lottiefiles/lottie-interactivity';

// Make available globally
window.lottie = lottie;
window.lottieInteractivity = { create };

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  if (typeof lottie !== 'undefined') {
    // Auto-initialize elements with .lottie class using IntersectionObserver
    // to lazy load animations only when they enter the viewport.
    const lottieObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const element = entry.target;
          const animationPath = element.dataset.animationPath;
          if (animationPath) {
            lottie.loadAnimation({
              container: element,
              renderer: 'svg',
              loop: element.dataset.loop !== 'false',
              autoplay: element.dataset.autoplay !== 'false',
              path: animationPath
            });
          }
          observer.unobserve(element);
        }
      });
    }, {
      rootMargin: '200px 0px'
    });

    document.querySelectorAll('.lottie').forEach(element => {
      lottieObserver.observe(element);
    });
  }
});